// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + ({"96":"vendors","117":"vendor-msal"}[chunkId] || chunkId) + "." + {"93":"76051cbd664dcf86be03","96":"1347cf178dcd7e711665","106":"e8f4e27958e451bec2e3","117":"d0d157b7584131b81809","220":"765ead5b67cf1757b1ba","512":"6e30c5a7eb296b08fef9","906":"6f26757bac2db65980bf","992":"ec3e92900d65aef506d4"}[chunkId] + ".js";
};